import {useHistory, useLocation} from "react-router";

import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {isApplicationAbroad} from "../../application/utils/form/is_application_abroad";
import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {OfferListSubType} from "../../offer/list/types/OfferListSubType";
import {getHomeMatchSearchRegions} from "../../region/utils/get_homematch_regions";
import {useHomeMatchPreferencesStorage} from "../../user/hooks/preferences/use_home_match_preferences_storage";
import {useUserSearchPreferences} from "../../user/hooks/use_user_search_preferences";
import {ILatestQuery} from "../../utils/latest_query";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {SearchTab} from "../types/SearchTab";
import {getSearchUrlWithFilters} from "../utils/get_search_url_with_filters";
import {saveRecentFilters} from "../utils/recent_filters_storage";

export interface IHookParams {
    multiRegionLink: () => string;
    latestQuery: ILatestQuery;
    listFriendlyLink: (params: {friendlySlug: string; offerListSubFilterSlug?: string}) => string;
    abroadListFriendlyLink: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
    offerListSubType?: OfferListSubType;
    onSearchSubmit?: (formValues: SearchFormValuesType, userQueryParams?: {distance?: number}) => void;
}

// Logic moved from apps/rp/src/common/search/components/Search.tsx
export function useSearchFormSubmit(params: IHookParams) {
    const location = useLocation();
    const history = useHistory();

    const {multiRegionLink, latestQuery, listFriendlyLink, abroadListFriendlyLink} = params;

    const {putPreferences: putHomeMatchPreferences} = useHomeMatchPreferencesStorage();
    const {saveUserPreferences} = useUserSearchPreferences();

    return async (formValues: SearchFormValuesType, userQueryParams?: {distance?: number}) => {
        if (params.onSearchSubmit) {
            params.onSearchSubmit(formValues, userQueryParams);
        }

        const searchValue = formValues["search"] as ISearchInputValue;

        if (searchValue.tabType === SearchTab.Offers) {
            return (window.location.href = createOfferLink({
                ...searchValue.offer,
                vendor: searchValue.vendor,
                groups: searchValue.offer.groups
            }));
        }

        if (searchValue.tabType === SearchTab.Vendors) {
            return (window.location.href = rpAppLink.vendor.detail.base({
                vendorSlug: searchValue.vendor.slug,
                vendorId: searchValue.vendor.id
            }));
        }

        const parsedSearch = parseSearch(location.search);
        const {url, filterValues} = getSearchUrlWithFilters({
            singleRegionFriendlyLink: listFriendlyLink,
            abroadListFriendlyLink: abroadListFriendlyLink,
            multiRegionLink,
            latestQuery,
            searchFormValues: formValues,
            additionalParams: {
                sort: parsedSearch.sort as string,
                distance: parsedSearch.distance as string,
                promotions: parsedSearch.promotions as string
            },
            userQueryParams: userQueryParams
        });

        const searchRegions = searchValue.tabType === SearchTab.Regions ? searchValue.regions : [];
        const isDomesticSearch = searchRegions.every((region) => !isApplicationAbroad(region.country));

        if (isDomesticSearch) {
            putHomeMatchPreferences({
                ...formValues,
                regions: getHomeMatchSearchRegions(searchRegions)
            });
        }

        if (searchValue.tabType === SearchTab.Regions && isDomesticSearch) {
            saveRecentFilters(formValues);
        }

        await saveUserPreferences({filters: filterValues});
        history.push(url);
    };
}
import {useHistory, useLocation} from "react-router";

import {parseSearch} from "@pg-mono/request";
import {rpAppLink} from "@pg-mono/rp-routes";

import {isApplicationAbroad} from "../../application/utils/form/is_application_abroad";
import {createOfferLink} from "../../offer/helpers/create_offer_link";
import {OfferListSubType} from "../../offer/list/types/OfferListSubType";
import {getHomeMatchSearchRegions} from "../../region/utils/get_homematch_regions";
import {useHomeMatchPreferencesStorage} from "../../user/hooks/preferences/use_home_match_preferences_storage";
import {useUserSearchPreferences} from "../../user/hooks/use_user_search_preferences";
import {ILatestQuery} from "../../utils/latest_query";
import {ISearchInputValue} from "../components/ISearchInputValue";
import {SearchFormValuesType} from "../types/SearchFormValuesType";
import {SearchTab} from "../types/SearchTab";
import {getSearchUrlWithFilters} from "../utils/get_search_url_with_filters";
import {saveRecentFilters} from "../utils/recent_filters_storage";

export interface IHookParams {
    multiRegionLink: () => string;
    latestQuery: ILatestQuery;
    listFriendlyLink: (params: {friendlySlug: string; offerListSubFilterSlug?: string}) => string;
    abroadListFriendlyLink: (params: {friendlySlug: string; country: string; abroadRegionSlug?: string}) => string;
    offerListSubType?: OfferListSubType;
    onSearchSubmit?: (formValues: SearchFormValuesType, userQueryParams?: {distance?: number}) => void;
}

// Logic moved from apps/rp/src/common/search/components/Search.tsx
export function useSearchFormSubmit(params: IHookParams) {
    const location = useLocation();
    const history = useHistory();

    const {multiRegionLink, latestQuery, listFriendlyLink, abroadListFriendlyLink} = params;

    const {putPreferences: putHomeMatchPreferences} = useHomeMatchPreferencesStorage();
    const {saveUserPreferences} = useUserSearchPreferences();

    return async (formValues: SearchFormValuesType, userQueryParams?: {distance?: number}) => {
        if (params.onSearchSubmit) {
            params.onSearchSubmit(formValues, userQueryParams);
        }

        const searchValue = formValues["search"] as ISearchInputValue;

        if (searchValue.tabType === SearchTab.Offers) {
            return (window.location.href = createOfferLink({
                ...searchValue.offer,
                vendor: searchValue.vendor,
                groups: searchValue.offer.groups
            }));
        }

        if (searchValue.tabType === SearchTab.Vendors) {
            return (window.location.href = rpAppLink.vendor.detail.base({
                vendorSlug: searchValue.vendor.slug,
                vendorId: searchValue.vendor.id
            }));
        }

        const parsedSearch = parseSearch(location.search);
        const {url, filterValues} = getSearchUrlWithFilters({
            singleRegionFriendlyLink: listFriendlyLink,
            abroadListFriendlyLink: abroadListFriendlyLink,
            multiRegionLink,
            latestQuery,
            searchFormValues: formValues,
            additionalParams: {
                sort: parsedSearch.sort as string,
                distance: parsedSearch.distance as string,
                promotions: parsedSearch.promotions as string
            },
            userQueryParams: userQueryParams
        });

        const searchRegions = searchValue.tabType === SearchTab.Regions ? searchValue.regions : [];
        const isDomesticSearch = searchRegions.every((region) => !isApplicationAbroad(region.country));

        if (isDomesticSearch) {
            putHomeMatchPreferences({
                ...formValues,
                regions: getHomeMatchSearchRegions(searchRegions)
            });
        }

        if (searchValue.tabType === SearchTab.Regions && isDomesticSearch) {
            saveRecentFilters(formValues);
        }

        await saveUserPreferences({filters: filterValues});
        history.push(url);
    };
}
